import { HgSupportedLanguage } from '@smg-real-estate/domus';
import { type GeoLocation, type GeoSearchResultItem } from '@smg-real-estate/geo-libs';

import { getDisplayValue } from '@/helpers/Geo/GeoLocationHelper';

// TODO Move to a library so that both seeker-app and entry-page share same logic

export function getHighlightedDisplayValue(
  // returns location with matching part in bold
  geoSearchResultItem: GeoSearchResultItem,
  language: HgSupportedLanguage,
): string {
  const parts: string[] = [];

  for (const name of geoSearchResultItem.geoLocation.names[language]) {
    let html = '';

    if (Object.hasOwnProperty.call(geoSearchResultItem.highlights, name)) {
      let i = 0;

      /* eslint-disable-next-line max-depth */
      for (const { from, to } of geoSearchResultItem.highlights[name]) {
        // skip invalid ranges
        /* eslint-disable-next-line max-depth */
        if (isInvalidRange(name, from, to)) {
          continue;
        }
        html += name.substring(i, from);
        html += `<b>${name.substring(from, to)}</b>`;
        i = to;
      }

      html += name.substring(i);
    } else {
      html = name;
    }

    parts.push(html);
  }

  return getDisplayValue(parts);
}

const isInvalidRange = (term: string, from: number, to: number): boolean =>
  from < 0 || from > term.length || to < 0 || to > term.length;

const showTypeLabel = (location: GeoLocation) => ['canton', 'region'].includes(location.type);

export function renderGeoLocationName(
  location: GeoLocation,
  language: HgSupportedLanguage,
): string {
  const [first, ...rest] = location.names[language];

  return [
    showTypeLabel(location) ? location.typeLabel?.[language] : undefined,
    rest.length > 0 ? `${first} (${rest.join(', ')})` : first,
  ]
    .filter((x) => !!x)
    .join(' ');
}
